module.exports = __webpack_public_path__ + "static/img/6358_phase_function_Paper_PointsHejduk_Prediction.d86d188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6358_phase_function_Paper_PointsHejduk_Prediction.png
// module id = w56P
// module chunks = 0